import { ReloadNotificationReducerState } from './types';

export const getDefaultState = (): ReloadNotificationReducerState => ({
  reloadNotificationId: null
});
